module.exports = __webpack_public_path__ + "static/media/thumb-up-gold.6fe0a775.svg";